import { Controller } from '@hotwired/stimulus';
import { gsap } from 'gsap';

export default class extends Controller {
  static targets = ['slide'];
  static values = {
    threshold: Number,
    rootMargin: String
  };

  connect() {
    this.initializeAnimation();
  }

  disconnect() {
    if (this.observer) {
      this.slideTargets.forEach((el) => this.observer.unobserve(el));
    }
    this.hideAllSlides();
  }

  initializeAnimation() {
    const observerOptions = {
      root: null,
      rootMargin: this.rootMarginValue || '0px 0px 0px 0px', // Default value if none is provided
      threshold: this.thresholdValue || 0 // Default value if none is provided
    };

    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      observerOptions
    );
    this.observeSlides();
  }

  observeSlides() {
    this.slideTargets.forEach((el) => this.observer.observe(el));
  }

  handleIntersection(entries) {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        this.animateSlide(entry.target, index);
        this.observer.unobserve(entry.target);
      }
    });
  }

  animateSlide(target, index) {
    const animationDelay = index * 100;
    gsap.to(target, {
      opacity: 1,
      y: 0,
      ease: 'power1.out',
      delay: animationDelay / 1000 // GSAP uses seconds for delay
    });
  }

  hideAllSlides() {
    gsap.set(this.slideTargets, { opacity: 0 });
  }
}
